var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.725,
    height: 20.671,
    viewBox: "0 0 20.725 20.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M12.638,11.8l.814-.6a.212.212,0,0,1,.106,0l5.758,7.787,1.015-1.015a1.428,1.428,0,0,0,.165-1.758c-1.322-2.891-2.608-5.534-3.54-8.259.153-.153.283-.342.437-.5a20.554,20.554,0,0,0,2.36-3.434c.212-.378.389-.72.578-1.1a1.734,1.734,0,0,0,.13-.92,1.652,1.652,0,0,0-.448-.861l-.26-.33A1.534,1.534,0,0,0,18.88.366a1.369,1.369,0,0,0-.92.118l-1.086.578a24.273,24.273,0,0,0-3.434,2.36,4.366,4.366,0,0,0-.5.437C10.1,2.843,7.458,1.557,4.567.236A1.4,1.4,0,0,0,2.808.4L1.794,1.416,9.582,7.174a.212.212,0,0,1,0,.106l-.625.791h0L6.7,11.02l-1.6,2.1a6.785,6.785,0,0,1-.684-.212c-1.322-.389-3.54-1-3.54-1L0,12.767l2.856,1.864.7.437.9.59a1.333,1.333,0,0,1,.319.26,1.286,1.286,0,0,1,.248.307l.59.9.437.7,1.864,2.855.861-.861s-.614-2.23-.991-3.54a6.631,6.631,0,0,0-.224-.684l2.112-1.6Z",
    transform: "translate(0 -0.001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.a7dc040a.svg";
export { ForwardRef as ReactComponent };